<template>
  <FormItem class="checkbox-form-item" :prop="$attrs.name" :label="label">
    <Checkbox v-bind="$attrs" v-on="$listeners">
      <span class="label">{{ $attrs.label }}</span>
      <slot />
    </Checkbox>
  </FormItem>
</template>
<script>
import { Checkbox, FormModel } from "ant-design-vue";

export default {
  components: {
    Checkbox,
    FormItem: FormModel.Item
  },
  props: {
    label: {
      type: String,
      default: ""
    }
  }
};
</script>

<style scoped lang="scss">
.checkbox-form-item {
  margin: 0;
  flex-direction: column;
  display: flex;
  .label {
    margin-left: 1rem;
  }
}
@media only screen and (max-width: 575px) {
  .checkbox-form-item {
    flex-direction: row;
  }
}
</style>
